export const SocketEvent = {
  CONNECTED_EVENT: "connected",
  DISCONNECTED_EVENT: "disconnect",
  NOTI_COUNT_EVENT: "notiCount",
  NEW_BOOKING: "newBooking",
  NEW_ORDER: "newOrder",
  ORDER_CANCELLED: "orderCancelled",
  DATE_CHANGE: "dateChange",
  AUTH_PERSON: "authPerson",
  PAYMENT_DECLINED: "paymentDeclined",
  PAYMENT_RECEIVED: "paymentReceived",
  ORDER_BOOKED: "orderBooked",
  ORDER_DECLINED: "orderDeclined",
  ORDER_COMPLETED: "orderCompleted",
  PICKUP_DAY: "pickupDay",
  RETURN_DAY: "returnDay",
  MARK_PICKUP: "markPickup",
  RETURNED: "returned",
  REVIEW_REMINDER: "reviewReminder",
};

// Conversation socket events live in the shared wire contract —
// import CONVERSATION_SOCKET_EVENTS from
// '@gearghost/api-schemas/conversation' (moved 2026-07-21; this local
// copy was one of three identical maps that could drift apart).
